import { ActionBase } from '../../../core/store/action/ActionBase';
import { CalOmsExtractWorkspaceModel } from "../../models/CalOmsExtractWorkspaceModel";

export const SAVE_EXTRACT = '[Extract] Save Extract';

export class SaveExtractAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = SAVE_EXTRACT;

  constructor(public payload: { model: CalOmsExtractWorkspaceModel[] }) {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/SaveExtractAction.ts